import { CAlert } from "@coreui/react";
import { Loading } from "./LoadingSpinner";
import LoadingOverlay from "react-loading-overlay-ts";
import { PropTypes } from "prop-types";
import { React } from "react";

const ReactQueryLoading = (props) => {
  let errorMessage = String(props.error);
  if (props.error?.response?.data) {
    if (props.error.response.data?.detail) {
      errorMessage = props.error.response.data.detail;
    } else {
      errorMessage =
        errorMessage +
        "\n" +
        String(JSON.stringify(props.error.response.data, null, 4));
    }
  }
  // Add line breaks to replace newlines in the error message
  return (
    <LoadingOverlay
      active={props.isLoading}
      spinner={
        <Loading height={props.loadingHeight} width={props.loadingHeight} />
      }
      // text="Loading..."
    >
      {!props.isLoading && props.status === "error" ? (
        <CAlert color="danger">
          {JSON.stringify(errorMessage)}
          {/* {errorMessage?.split("\n").map((v) => (
            <>
              {v}
              <br />
            </>
          ))} */}
        </CAlert>
      ) : (
        props.children
      )}
    </LoadingOverlay>
  );
};
ReactQueryLoading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
  error: PropTypes.any,
  loadingHeight: PropTypes.string,
  children: PropTypes.any,
};

ReactQueryLoading.defaultProps = {
  loadingHeight: "75em",
};

export default ReactQueryLoading;
